module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_major/uma_names-53f3407682e85515676d6dfd8d50e799.gif";